"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TelegramBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_i18next_1 = require("react-i18next");
const svg_selector_1 = require("../../assets/svg-selector");
const telegram_banner_module_css_1 = __importDefault(require("./telegram-banner.module.css"));
const TelegramBanner = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(react_router_dom_1.Link, { className: telegram_banner_module_css_1.default.inner, target: "_blank", to: "https://t.me/delab", children: [(0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "telegram" }), (0, jsx_runtime_1.jsxs)("div", { className: telegram_banner_module_css_1.default.innerActions, children: [(0, jsx_runtime_1.jsx)("p", { children: t('common.telegram-description') }), (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "chevron-right-gray" })] })] }));
};
exports.TelegramBanner = TelegramBanner;
